/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_CriteriaInputs */

const cs_demands_criteria = /** @type {(inputs: Demands_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritéria`)
};

const en_demands_criteria = /** @type {(inputs: Demands_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criteria`)
};

/**
* | output |
* | --- |
* | "Criteria" |
*
* @param {Demands_CriteriaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_criteria = /** @type {((inputs?: Demands_CriteriaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_CriteriaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_criteria(inputs)
	return cs_demands_criteria(inputs)
});